import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { DocumentInfoType } from 'models/Listing';
import { sortByName } from 'utils';

export const getDocumentOptions = (
  documents?: DocumentInfoType[],
): RadioOption<string>[] =>
  sortByName(documents).map(({ fileId, name }) => ({
    label: name,
    value: fileId,
  }));
